import { render, staticRenderFns } from "./InsuranceDrawer.vue?vue&type=template&id=022456e1&scoped=true"
import script from "./InsuranceDrawer.vue?vue&type=script&lang=ts"
export * from "./InsuranceDrawer.vue?vue&type=script&lang=ts"
import style0 from "./InsuranceDrawer.vue?vue&type=style&index=0&id=022456e1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022456e1",
  null
  
)

export default component.exports